import { resetUser } from "services/GA"

export function clearAuthStorage() {
	resetUser()
	sessionStorage.removeItem('auth-token')
	sessionStorage.removeItem('auth-profile')
}
